import { SierraConfig } from './types';

export const sierraAgentToken = 'nYtGsLQBjnEM61MBjnENRUIsnqxbkIyMBwPyoArR1Xk';

export const launchSierra = () => {
  if (!window?.sierra?.openChatModal) return;
  const { sierra } = window;

  sierra.openChatModal();
};

export const hideSierra = () => {
  if (!window?.sierra?.closeChatModal) return;
  const { sierra } = window;

  sierra.closeChatModal();
};

export const sierraConfig: SierraConfig = {
  preload: 'none',
  display: 'modal',
  dimensions: {
    width: '600px',
    height: '650px'
  },
  persistence: 'tab'

  //  removing this for now -- will potentially re-add

  // onTransfer: (transfer) => {
  //   const { Gladly } = window;
  //   if (!Gladly) return;

  //   const { data } = transfer;
  //   hideSierra();

  //   Gladly.clearUser();
  //   if (data.emailAddress) {
  //     Gladly.setUser({ email: data.emailAddress, name: data.emailAddress });
  //   }
  //   Gladly.show();

  //   setTimeout(() => {
  //     const gladlySubmit = document.querySelector<HTMLElement>('[data-aid=selfService-chatButton]');
  //     if (gladlySubmit) gladlySubmit.click();
  //   }, 400);
  // }
};
